<template>
  <div
    :class="[
        'form-part--field',
        showError ? 'err' : '',
        showValid ? 'valid' : '',
        fullWidth ? 'flex-full' : '',
        disabled ? 'disabled' : '',
        rounded ? 'rounded' : '',
        circle ? 'circle' : '',
        externalLabel ? 'external-label' : sideLabel ? 'side-label' : '',
        internalLabel ? 'internal-label' : '',
        fat ? 'fat' : '',
        fieldType
    ]">
    <!-- req ? 'req' : '', -->
    <transition name="fade" appear>
      <slot v-if="value" name="pswmeter"></slot>
    </transition>
    <vue-pikaday
      ref="field"
      v-if="fieldType === 'date'"
      v-model="inputValue"
      :default-date="new Date()"
      :options="pikadayMergedOptions"
      :placeholder="labelIsPlaceholder && label ? label : null"
      @input="updateVal"
      set-default-date
    />
    <textarea
      ref="field"
      :id="label + fieldIndex"
      :placeholder="labelIsPlaceholder && label ? label : null"
      :value="value"
      @input="updateVal"
      v-else-if="fieldType === 'textarea'"
    ></textarea>
    <input
      @focus="$emit('focus', $el)"
      @blur="$emit('blur', $el)"
      v-else-if="fieldType !== 'select'"
      :maxlength="maxlength"
      :minlength="minlength"
      :class="[
        value ? 'has-value' : '',
        background ? `bg-${background}` : '',
        color ? `text-${color}` : ''
      ]"
      ref="field"
      :type="finalFieldType"
      :value="value"
      :checked="value"
      @input="updateVal"
      :id="label + fieldIndex"
      :disabled="disabled"
      :placeholder="labelIsPlaceholder && label ? label : null"
      :hidden="fieldType === 'checkbox'"
      :autocomplete="finalFieldType === 'password' ? `new-password` : false"
    />
    <select
      :class="[
          locale == 'HE' ? 'rtl':'',
          disabled ? 'disabled' : '',
          multi ? 'multiselect' : '',
          wide ? 'wide' : ''
      ]"
      ref="field"
      :value="value || 0"
      @input="updateVal"
      :id="label + fieldIndex"
      v-else
    >
      <option
        v-if="selectPlaceholder"
        key="0"
        value="0"
        v-text="selectPlaceholder"
        disabled
      ></option>
      <option
        v-for="opt in parsedSelectOptions"
        :key="opt.value"
        v-text="localize(opt.label)"
        :value="opt.value"
      ></option>
    </select>

    <template v-if="!labelIsPlaceholder">
      <label
        :class="[
          fieldType === 'checkbox'
            ? 'checkbox-trig mr-xs'
            : externalLabel
            ? 'external'
            : sideLabel
            ? 'mr-xs'
            : 'internal',
            locale == 'HE' ? 'rtl':'',
            labelColor ? `text-${labelColor}` : '',
          req ? 'req' : ''
        ]"
        v-if="fieldType === 'checkbox' || (label && !hideLabel)"
        :for="label + fieldIndex"
      >
        <span v-html="label"></span>
      </label>
    </template>
    <span v-if="icon || validIcon" :class="['icon-wrap',locale == 'HE' ? 'rtl':'']">
      <transition name="fade" appear>
        <i
          v-if="serverValidation === 'pending' && valid"
          class="valid fal fa-spin fa-circle-notch"
        ></i>
        <i
          v-else-if="
            valid &&
              validIcon &&
              (serverValidation === 'none' || serverValidation === true)
          "
          class="valid fas fa-check"
        ></i>
        <i v-else-if="icon" :class="['fal', `fa-${icon}`, iconColor]"></i>
      </transition>
      <i
        @click="
          internalFieldType =
            finalFieldType === 'password' ? 'text' : 'password'
        "
        v-if="fieldType === 'password' && !disabled && value"
        :class="[
          'psw-eye-icon',
          'far',
          finalFieldType === 'password' ? 'fa-eye' : 'fa-eye-slash'
        ]"
      ></i>
    </span>
    <transition name="fade-slide" appear>
      <label
        v-if="showError && errMsg"
        :for="label + fieldIndex"
        class="err-msg"
      >
        <i class="fas fa-exclamation-circle mr-xs"></i>
        <span
          v-text="req && !finalValue ? localize('this_fileld_required') : localize(errMsg)"
        ></span>
      </label>
      <div v-if="showValid && validMsg" class="valid-msg">
        <i class="fas fa-check-circle mr-xs"></i>
        <span v-text="validMsg"></span>
      </div>
    </transition>
  </div>
</template>

<script>
// import moment from "moment";
// import { MazPhoneNumberInput } from "maz-ui";

export default {
  name: "form-field",
  props: {
    triggerValidation: {
      type: Number,
      default: -1
    },
    fat: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    forceCss: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: 'EN'
    },
    labelIsPlaceholder: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Object, Date, Boolean, Event]
    },
    maxlength: {
      type: [String, Number],
      default: 100
    },
    minlength: {
      type: [String, Number],
      default: 0
    },
    externalLabel: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    sideLabel: {
      type: Boolean,
      default: false
    },
    fieldIndex: {
      type: Number,
      default: 0
    },
    req: {
      type: Boolean,
      default: false
    },
    // prop: String,
    disabled: {
      type: Boolean,
      default: false
    },
    /*
      Option for perfect circle display mode
    */
    circle: {
      type: Boolean,
      default: false
    },
    err: {
      type: Boolean,
      default: false
    },
    errMsg: {
      type: String,
      default() {
        if (this.req) {
          return 'this_fileld_required';//this.localize('this_field_is_required');
        }
        return null;
      }
    },
    valid: {
      type: Boolean,
      default: false
    },
    validMsg: {
      type: [Boolean, String],
      default: null
    },
    validIcon: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },
    /* option for custom input text color */
    color: {
      type: String,
      default: null
    },
    /* option for custom label text color */
    labelColor: {
      type: String,
      default: null
    },
    /* option for custom background color */
    background: {
      type: String,
      default: null
    },
    fieldType: {
      type: String,
      default: "text"
    },
    pikadayRefreshDate: {
      type: Boolean,
      default: false
    },
    pikadayMoreOptions: {
      type: Object
    },
    selectOptions: {
      type: Array,
      default: null
    },
    selectPlaceholder: {
      type: String,
      default: null
    },
    selectLabel: {
      type: String,
      default: "name"
    },
    selectValue: {
      type: String,
      default: "id"
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    wide: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    validation: {
      type: [RegExp, String],
      default: null
    },
    serverValidation: {
      type: [Boolean, String], // API
      default: "none"
    }
  },
  // components: {
  //   MazPhoneNumberInput
  // },
  data() {
    return {
      monthList:[],
      triggerFinalValue: -1,
      internalDirty: false,
      internalFieldType: null,
      // date: null,
      inputValue: null,
      pikadayOptions: {
        format: "DD/MM/YYYY",
        minDate: new Date(),
        i18n:{
            previousMonth : this.localize('previous_month'),
            nextMonth     : this.localize('next_month'),
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        }
      }
      //pikadayOptions.i18n.months = 
    };
  },
  beforeMount() {},
  mounted() {

    var vm = this;

    //Translate the datepicker lables
    let _months = [vm.localize('january'),vm.localize('february'),vm.localize('march'),vm.localize('april'),vm.localize('may'),vm.localize('june'),vm.localize('july'),vm.localize('august'),vm.localize('september'),vm.localize('october'),vm.localize('november'),vm.localize('december')];
    this.pikadayOptions.i18n.months = _months;

    let _weekdays = [vm.localize('Sunday'),vm.localize('Monday'),vm.localize('Tuesday'),vm.localize('Wednesday'),vm.localize('Thursday'),vm.localize('Friday'),vm.localize('Saturday')];
    this.pikadayOptions.i18n.weekdays = _weekdays;

    let _weekdaysShort = [vm.localize('Sun'),vm.localize('Mon'),vm.localize('Tue'),vm.localize('Wed'),vm.localize('Thu'),vm.localize('Fri'),vm.localize('Sat')];
    this.pikadayOptions.i18n.weekdaysShort = _weekdaysShort;


    // this.$eventHub.on("fields-listen", this.setListeners);
    this.checkDirty();
    if (this.req) {
      this.$eventHub.off("force-validate", this.validateSelf);
      this.$eventHub.on("force-validate", this.validateSelf);
      this.validateSelf();
    }
    if (this.fieldType === "date") {
      if (this.value) {
        this.inputValue = new Date(this.value);
      }
    }
  },
  destroyed() {
    if (this.label) {
      let prop = this.label + this.fieldIndex;
      console.log("field destroyed >> ", prop);
      this.$emit("remove-validation", prop);
    }
  },
  watch: {
    req() {
      if (this.req) {
        this.$eventHub.off("force-validate", this.validateSelf);
        this.$eventHub.on("force-validate", this.validateSelf);
        this.validateSelf();
      } else {
        this.$eventHub.off("force-validate", this.validateSelf);
      }
    },
    value() {
      if (this.fieldType === "date") {
        if (!this.value) {
          this.inputValue = this.value;
        }
      }
    },
    triggerValidation() {
      this.validateSelf();
    },
    inputValue() {
      this.checkDirty();
    },
    disabled() {
      if (this.disabled) {
        this.$refs.field.value = null;
        // this.$set(this, "value", null);
        this.updateVal();
      }
    },
    pikadayMergedOptions: {
      deep: true,
      handler() {
        this.$nextTick(function() {
          if (this.pikadayRefreshDate) {
            this.$refs.field.pikaday.gotoDate(
              new Date(this.pikadayMergedOptions.minDate)
            );
          }
        });
      }
    }
  },
  methods: {
    validateSelf() {
      this.$nextTick(function() {
        let val = this.finalValue;
        let isvalid = true;
        if (this.req && (!val || this.err)) {
          isvalid = false;
        }
        if (val && val.length) {
          if (val.length < this.minlength || val.length > this.maxlength) {
            isvalid = false;
          }
        }
        if (this.label) {
          this.$emit("validate-field", this.label + this.fieldIndex, isvalid);
        }
        return isvalid;
      });
    },
    checkDirty() {
      let val = this.finalValue;
      if (val && val.length) {
        this.internalDirty = true;
      }
    },
    trigFinalVal() {
      this.triggerFinalValue = new Date().getTime();
    },
    updateVal() {
      this.trigFinalVal();
      this.checkDirty();
      if (this.fieldType === "date") {
        this.$emit("input", this.inputValue);
      } else if (this.fieldType === "checkbox") {
        this.$emit("input", !JSON.parse(this.$refs.field.value));
      } else {
        this.$emit("input", this.$refs.field.value);
      }
      this.validateSelf();
    }
  },
  computed: {
    getMonthList()
    {
      var vm = this;
      let months = [vm.localize('january'),vm.localize('february'),vm.localize('march'),vm.localize('april'),vm.localize('may'),vm.localize('june'),vm.localize('july'),vm.localize('august'),vm.localize('september'),vm.localize('october'),vm.localize('november'),vm.localize('december')];
      return months;
    },
    

    parsedSelectOptions() {
      let s = this.selectOptions;
      if (s) {
        // console.log(this.selectLabel, " :: ", this.selectValue);
        if (typeof s[0] === "string") {
          // Array of Strings...
          return s.map(opt => {
            return {
              label: opt,
              value: opt
            };
          });
        }
        if (s[0][this.selectLabel]) {
          return s.map(opt => {
            return {
              label: opt[this.selectLabel],
              value: opt[this.selectValue]
            };
          });
        }
        return s;
      }
      return null;
    },
    finalFieldType() {
      return this.internalFieldType || this.fieldType;
    },
    finalDirty() {
      return this.dirty || this.internalDirty;
    },
    finalValue() {
      // this.$refs.field.value does not trigger this compute... trigger needed.
      this.triggerFinalValue;
      return this.value
        ? this.value
        : this.inputValue
        ? this.inputValue
        : // This hack is for select with placeholder ("0")
        this.$refs.field &&
          this.$refs.field.value &&
          this.$refs.field.value !== "0"
        ? this.$refs.field.value
        : null;
    },
    // hasError() {
    //   return this.err || (this.finalDirty && this.req && !this.finalValue);
    // },
    showError() {
      return this.finalDirty && (this.err || (this.req && !this.finalValue));
    },
    showValid() {
      return this.finalDirty && !this.err && this.valid;
    },
    pikadayMergedOptions() {
      return {
        ...this.pikadayOptions,
        ...this.pikadayMoreOptions
      };
    },
    internalLabel() {
      return !this.externalLabel && !this.sideLabel && !this.labelIsPlaceholder;
    }
  }
};
</script>

<style lang="stylus">
&.req:after
    content '*'
    transform translateY(0)
    line-height 1
    font-size 13px
    color gray_6
.form-part--field
  position relative
  _flex(column-reverse, wrap, flex-start, flex-start)
  marg(l, 'bottom')
  &:not(.stretch)
    max-width 360px
  &.side-label
    _flex(row-reverse, nowrap, center, flex-start)
    marg('0', bottom)
    label
      flex none
  /.field-group &
    marg('0', bottom)
  flex 0 0 100%
  & > .external
    marg('xs', bottom)
  &.checkbox
  &.radio
    _flex(row-reverse, wrap, flex-start, flex-end)
    & > .external
      marg(0)
    .checkbox-trig
      _flex(row, nowrap, center, flex-start)
      &:before
        content ''
        display inline-block
        border 1px solid gray_6
        width 16px
        height @width
        border-radius 2px
        background #fff
        marg('xs', right)
        transition background 0.3s ease-out
      /.check-group &:before
        content initial

    input[type='checkbox']:checked
      & ~ .checkbox-trig:before
      & ~ .checkbox-trig span:before
        background blue_brand
  &.f50
    flex 0 0 48% !important
  &.rounded
    & > input
    & > select
    & > textarea
      border-radius 20px
      padding 0 16px
    &.fat
      & > input
      & > select
      & > textarea
        border-radius 27px
    &.internal-label > input
      padding-top 7px
  &.circle
    & > input
      border 0
      round(44, 'px')
      padding 0
      font-size 110%
      font-weight 400
  .icon-wrap
    &.rtl
      left 10px
      right initial
    position absolute
    top 50%
    transform translateY(-50%)
    right 10px
    color gray_6
    _flex(row, nowrap, center, center)
    pointer-events pass-through
    & > *
      margin-right 4px
      min-width 20px
      text-align center
    .valid
      color c_valid
  .external + .icon-wrap
    transform none
    top 58%

  &.err
    input
    select
      border-color red_4 !important
  &.valid
    input
      border-color c_valid !important
  /.field-group &
    flex 1
input
select
  border-radius 1px
  border 1px solid gray_7
  border-color inherit
  transition border 0.2s ease-out
  &:focus
    outline none
select
  /.field-group &
  &.multiselect
    -webkit-appearance none
    position relative
    height 44px
    background url('/img/chevron-down.svg') no-repeat calc(100% - 16px) 50% / auto 40%
    min-width 100px
    width 100%
    color gray_7
    font-size 13px
    pad('s', x)
    &.green-arrow
      background-image url('/img/chevron-down-green.svg')
    &:after
      content ''
      background red
      position absolute
      top 0
      left 0
      width 100%
      height 100%
  /.field-group &
  &.fullw
    width 100%
  &.rtl    
    background-position 20px 50%
    &.multiselect
      background-position 20px 50%

label
  color gray_6
  display block
  font-size 13px
  transition left 0.2s ease-out, top 0.2s ease-out, font-size 0.2s ease-out, color 0.2s ease-out
  &.internal
    position absolute
    top 13px
    left 15px
    &.rtl
      right 15px      
    //right 15px
    input
      padding-top 7px
    input:focus ~ &
    input.has-value ~ &
    /.has-value &
      top 0
      left 0.5vw
      font-size 11px
      color gray_6
      /.rounded &
        left 15px
input:not([type='checkbox'])
textarea
  width 100%
  border 1px solid gray_6
  height 44px
  padding 7px 16px 0
  resize none
  transition border .5s ease-out
  /.fat &
    height 54px
    +below(815px)
      height 48px
      font-size 16px
  td &
    height auto
    border none
    border-radius 0 !important
    border-bottom 1px solid gray_3
    background rgba(#fff, 0.2)
    padding 2px 6px
  &:disabled
    //background rgba(gray_4, 0.4)
    ~ label
      color gray_4
  &:focus
    outline none
    border-color rgba(darken(blue_brand, 20), 0.6)
    border-style dashed
    td &
      border 0
      // border-bottom-color darken(blue_brand, 50)
      // border-bottom-style dashed
      border-bottom 1px dashed darken(blue_brand, 50) !important

textarea
  height 160px
  padding-top 12px !important
select.disabled
  pointer-events none
  background gray_2

.err-msg
  position absolute
  bottom -13px
  right 0
  font-size 12px
  color red_2
  white-space nowrap
  backface-visibility hidden
  transition opacity 0.2s ease-out
  background rgba(#fff, 0.4)
  input:not([type='email']):focus ~ &
    opacity 0
.valid-msg
  @extend .err-msg
  color green_2
</style>
<style lang="stylus">
// pikaday
.pika-row
  .pika-button:hover
    background gray_4
  .is-today .pika-button
    color blue_brand
  .has-event .pika-button
  .is-selected .pika-button
      color #fff
      font-weight 700
      background blue_brand
      box-shadow inset 0 1px 3px lighten(blue_brand, 20)
      border-radius 3px
      /.is-today &
        color #fff
// PASSWORD meter
  .po-password-strength-bar
    position absolute
    right 0
    top 0
    height 20px !important
    transform translateY(-155%)
    margin-top auto
    _flex(row, wrap, center, center)
    line-height 1
    background none !important
    &:before
      content "Password Strength:"
      font-size 11px
      margin-right 4px
    &:after
      content ""
      font-family "Font Awesome 5 Pro"
      font-weight 900
      font-size 18px
      // transition background 0.2s ease-out
      transition background-color 0.4s ease-out, color 0.4s ease-out, transform 0.4s ease-out
      color red_4
      transform-origin center
      transform rotate(-360deg)
      background-color #f95e68
      width 20px
      height @width
      border-radius 10px
      line-height 1.3
      text-align center
      overflow hidden
    &.risky:after
      color #f95e68
      background-color rgba(#f95e68, 0.9)
      transform rotate(-180deg)
    &.guessable:after
      color #fb964d
      transform rotate(-120deg)
      background-color rgba(#f95e68, 0.75)
      // background-color #fb964d
    &.weak:after
      color #fdd244
      transform rotate(-75deg)
      background-color rgba(#fdd244, 0.75)
      // background-color #fdd244
    &.safe:after
      color #b0dc53
      transform rotate(-15deg)
      background-color rgba(#f95e68, 0)
      // background-color #b0dc53
    &.secure:after
      transform rotate(0deg)
      background-color rgba(#f95e68, 0)
      color #35cc62
      // background-color #35cc62

// MAZ INPUT COMPONENT (phone number)
.maz-base-component
  input
    border 1px solid gray_4
    border-radius 1px
    padding-bottom 0
    &:not(.maz-textarea)
      min-height 44px
      height 44px
  &.is-focused
    input
      border 0
      border-bottom 1px dashed darken(blue_brand, 50) !important
  .maz-input.is-valid .maz-input__label
    color blue_6 !important
</style>
